jQuery(document).ready(function() {

  var hiddenContentResultClassName = 'hidden-content-result';
  var visibleContentResultClassName = 'visible-content-result';
  var contentResultClassName = 'content-result';

  var numberToMove = 4;
  $('.arrow-nav.left-nav').on('click', function() {
    var el = $(this);
    if(!el.hasClass('click') && !el.hasClass('disabled')) {
      moveToNextFrame(numberToMove, 'left', $('.content-carousel'));
      el.addClass('click');
      setTimeout(function () {
        el.removeClass('click');
      }, 100);
    }
  });
  $('.arrow-nav.right-nav').on('click', function() {
    var el = $(this);
    if(!el.hasClass('click') && !el.hasClass('disabled')) {
      moveToNextFrame(numberToMove, 'right', $('.content-carousel'));
      el.addClass('click');
      setTimeout(function () {
        el.removeClass('click');
      }, 100);
    }
  });

  /**
   * Carosel effect. Shows new content and hides the previous ones in a certain direction given
   *
   * @param numberFramesToMove number of content to show next
   * @param direction which way to 'scroll' through
   * @param parentElement div container you want to carousel through
   */
  function moveToNextFrame(numberFramesToMove, direction, parentElement) {
    var visibleElements = parentElement.find('.' + visibleContentResultClassName);
    var allResults = parentElement.find('.' + contentResultClassName);
    var currentIndex = 0;

    if (direction === 'right') {
      currentIndex = $(allResults).index($(visibleElements).last());
      $('.arrow-nav.left-nav').removeClass('disabled');
    } else {
      currentIndex = $(allResults).index($(visibleElements).first());
      $('.arrow-nav.right-nav').removeClass('disabled');
    }

    var itemsToShow = [];
    var overlap = false;
    for (var i = 0; i < numberFramesToMove; i++) {
      if (direction === 'right') {
        if ($(allResults).eq(currentIndex + 1).length > 0 && !overlap) {
          currentIndex++;
        } else {
          currentIndex--;
          overlap = true;
        }
      } else {
        if ($(allResults).eq(currentIndex + 1).length > 0 && !overlap) {
          currentIndex--;
          if (currentIndex < 0) {
            currentIndex = 1;
            overlap = true;
          }
        } else {
          currentIndex++;
        }
      }

      if (currentIndex >= allResults.length-1) {
        $('.arrow-nav.right-nav').addClass('disabled');
      } else if (currentIndex <= 0) {
        $('.arrow-nav.left-nav').addClass('disabled');
      }

      var result = $(allResults).eq(currentIndex);
      if (result.length > 0) {
        itemsToShow.push(result);
      }
    }

    if (itemsToShow) {
      visibleElements.removeClass(visibleContentResultClassName).addClass(hiddenContentResultClassName);
      for (var j = 0; j < itemsToShow.length; j++) {

        $(itemsToShow[j]).removeClass(hiddenContentResultClassName).addClass(visibleContentResultClassName).css('opacity', 0);
      }

      parentElement.find('.' + visibleContentResultClassName).animate({
        opacity: 1
      }, 500, function() {});
    }
  }


  /**
   * Removes or adds content cards depending on how many needed to show
   *
   * @param num the number of cards to view
   * @param parentElement
   */
  function showOnly(num, parentElement) {
    var visibleElements = parentElement.find('.' + visibleContentResultClassName);
    var allResults = parentElement.find('.' + contentResultClassName);
    var currentIndex = $(allResults).index($(visibleElements).first());
    var itemsToShow = [];

    var count = 0;
    while (count < num) {
      var result = $(allResults).eq(currentIndex);
      itemsToShow.push(result);
      currentIndex++;
      count++;
    }

    if (itemsToShow) {
      visibleElements.removeClass(visibleContentResultClassName).addClass(hiddenContentResultClassName);
      for (var j = 0; j < num; j++) {
        $(itemsToShow[j]).removeClass(hiddenContentResultClassName).addClass(visibleContentResultClassName);
      }
    }

    if (itemsToShow.length === allResults.length) {
      $('.arrow-nav.right-nav').hide();
      $('.arrow-nav.left-nav').hide();
    } else {
      $('.arrow-nav.right-nav').show();
      $('.arrow-nav.left-nav').show();
    }
  }

  resizedCarousel();
  window.addEventListener('resize', resizedCarousel);

  //Eventlistener to check current resolution of screen and show a certain amount of content cards
  function resizedCarousel() {
    if (document.documentElement.clientWidth < 675) {
      numberToMove = 1;
    } else if (document.documentElement.clientWidth < 915) {
      numberToMove = 2;
    } else if (document.documentElement.clientWidth < 1160) {
      numberToMove = 3;
    } else {
      numberToMove = 4;
    }
    showOnly(numberToMove, $('.content-carousel'));
  }
});
